export default __webpack_public_path__ + "static/banner-how-to-budget-like-a-pro-4613bb68e44a89876b5f1f2fb6ae54c8.jpg";